import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { useHistory, Link } from "react-router-dom";
import { 
    Divider, Paper, TextField, Button, FormControl, MenuItem, Grid, 
    Radio, RadioGroup, FormControlLabel, FormLabel, InputLabel, 
    Select, Input, Checkbox, ListItemText, Typography, Card, 
    CardContent, FormHelperText, CircularProgress 
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { ROLENAME, designDepartment, salesDepartment } from '../../utils/index';
import { Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Box, Accordion, AccordionSummary, AccordionDetails, AccordionActions } from '@material-ui/core';
import moment from 'moment';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import HttpService from '../../services/httpService'
import { setUserDetails } from '../../redux/actions/userAction';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import isEmpty from 'lodash/isEmpty';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    tablealign: {
        display: "flex"
    },
    tablecontainer: {
        display: "flex",
        marginTop: "25px"
    },
    avatarContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    textField: {
        margin: '30px',
        width: '80%',
    },
    FormControl: {
        margin: '30px'
    },
    dateField: {
        width: "250px",
        margin: '30px',
    },
    textFieldContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    autocompleteContainer: {
        width: "300px",
        marginBottom: 10,
        marginLeft: 25
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2)
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const ChmTicketForm = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { userDetails } = useSelector(state => state.user)

    const [ticketTitle, setTicketTitle] = useState('');
    const [otherProjectDetails, setOtherProjectDetails] = useState({
        name: '',
        mobile: '',
        email: ''
    });
    const [ticketDescription, setTicketDescription] = useState('');
    const [ticketETAdate, setTicketETAdate] = useState('');
    const [ticketFollowUpDate, setTicketFollowUpDate] = useState('');

    const [selectedTagValue, setSelectedTagValue] = useState('uniqueLeadNumber');
    const [searchInput, setSearchInput] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [isSearching, setIsSearching] = useState(false);

    const [autoComplete, setAutoComplete] = useState(JSON.parse(localStorage.getItem('CHMTicketLeadDetails')));

    const [leadNoData, setLeadNoData] = useState([]);
    const [uniqueLeadNoData, setUniqueLeadNoData] = useState([]);
    const [projectNoData, setProjectNoData] = useState([]);

    const [files, setFiles] = useState([""]);
    const [allDepartments, setAllDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState({});
    const [usersOfSelectedTeam, setUsersOfSelectedTeam] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [selectedTeam, setSelectedTeam] = useState({});
    const [categoryData, setCategoryData] = useState([]);
    const [selectedCategoryData, setSelectedCategoryData] = useState({});
    const [completeLeadData, setCompleteLeadData] = useState(JSON.parse(localStorage.getItem('CHMTicketLeadDetails')));

    // Initialize component
    useEffect(() => {
        categoryDataApi();
        getDatadepartments();
 
    }, []);

    // Reset form fields
    const resetFormFields = () => {
        setTicketTitle('');
        setOtherProjectDetails({
            name: '',
            mobile: '',
            email: ''
        });
        setTicketDescription('');
        setTicketETAdate('');
        setTicketFollowUpDate('');
        setSelectedTagValue('uniqueLeadNumber');
        setSearchInput('');
        setAutoComplete(null);
        setFiles([""]);
        setSelectedDepartment({});
        setUsersOfSelectedTeam([]);
        setSelectedUser({});
        setSelectedTeam({});
        setSelectedCategoryData({});
        setCompleteLeadData(null);
        // Clear search data
        setLeadNoData([]);
        setUniqueLeadNoData([]);
        setProjectNoData([]);
    };

    // Handle search input change with debouncing
    const handleSearchInputChange = async (event, value) => {
        setSearchInput(value);
        
        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        
        // If input is too short, clear the data
        if (!value || value.length < 2) {
            clearCurrentSearchData();
            return;
        }
        
        // Set new timeout for debouncing
        const timeout = setTimeout(async () => {
            await performSearch(value);
        }, 500); // 500ms delay
        
        setSearchTimeout(timeout);
    };

    // Clear current search data
    const clearCurrentSearchData = () => {
        if (selectedTagValue === "lead_no") {
            setLeadNoData([]);
        } else if (selectedTagValue === "erpProjectNo") {
            setProjectNoData([]);
        } else if (selectedTagValue === "uniqueLeadNumber") {
            setUniqueLeadNoData([]);
        }
    };

    // Perform the actual search
    const performSearch = async (searchValue) => {
        if (!selectedTagValue || searchValue.length < 2) {
            clearCurrentSearchData();
            return;
        }
        
        try {
            setIsSearching(true);
            const response = await HttpService.getAllLeadDetailsForCHMticketGeneration(
                selectedTagValue, 
                searchValue
            );
            
            // Update the appropriate state based on selected tag
            const searchResults = response.data || [];
            
            if (selectedTagValue === "lead_no") {
                setLeadNoData(searchResults);
            } else if (selectedTagValue === "erpProjectNo") {
                setProjectNoData(searchResults);
            } else if (selectedTagValue === "uniqueLeadNumber") {
                setUniqueLeadNoData(searchResults);
            }
            
        } catch (error) {
            console.error('Search error:', error);
            props.setSnackInfo('Search failed. Please try again.', 'error');
            clearCurrentSearchData();
        } finally {
            setIsSearching(false);
        }
    };

    // Handle lead tag change
    const handleLeadTagChange = async (e) => {
        const newValue = e.target.value;
        setSelectedTagValue(newValue);
        setAutoComplete(null);
        setSearchInput('');
        clearCurrentSearchData();
    };

    // Handle lead selection from autocomplete
    const handleLeadSelectionAutoComplete = async (e, v) => {
        setAutoComplete(v);
        if (v && v._id) {
            try {
                props.setLoading(true);
                const response = await HttpService.getLeadDetailsForChmTicket(v._id);
                setCompleteLeadData(response.data);
                // Store in localStorage if needed
                localStorage.setItem('CHMTicketLeadDetails', JSON.stringify(response.data));
            } catch (error) {
                console.error('Error fetching lead details:', error);
                props.setSnackInfo('Failed to load lead details', 'error');
            } finally {
                props.setLoading(false);
            }
        } else {
            setCompleteLeadData(null);
            localStorage.removeItem('CHMTicketLeadDetails');
        }
    };

    // Get current data based on selected tag
    const getCurrentData = () => {
        if (selectedTagValue === "lead_no") {
            return leadNoData;
        } else if (selectedTagValue === "erpProjectNo") {
            return projectNoData;
        } else if (selectedTagValue === "uniqueLeadNumber") {
            return uniqueLeadNoData;
        }
        return [];
    };

    // Get option label for autocomplete
    const getOptionLabel = (option) => {
        if (!option) return '';
        const value = option[selectedTagValue];
        if (value === null || value === undefined) return '';
        return value.toString();
    };

    // Form validation
    const validateForm = () => {
        if (selectedTagValue === 'other') {
            return (
                ticketTitle &&
                ticketDescription &&
                ticketETAdate &&
                ticketFollowUpDate &&
                otherProjectDetails.name &&
                otherProjectDetails.mobile &&
                otherProjectDetails.email &&
                !isEmpty(selectedDepartment) &&
                !isEmpty(selectedTeam) &&
                !isEmpty(selectedUser) &&
                !isEmpty(selectedCategoryData)
            );
        } else {
            return (
                ticketTitle &&
                ticketDescription &&
                ticketETAdate &&
                ticketFollowUpDate &&
                autoComplete &&
                !isEmpty(autoComplete) &&
                !isEmpty(selectedCategoryData)
            );
        }
    };

    // Handle form submission for "other" type
    const handleOtherTicket = async (e) => {
        if (!validateForm()) {
            props.setSnackInfo('Please fill all required fields', 'warning');
            return;
        }
        
        try {
            const obj = {
                ticketTitle: ticketTitle,
                ticketDescription: ticketDescription,
                ticketETAdate: ticketETAdate,
                ticketFollowUpDate: ticketFollowUpDate,
                selectedTagValue: selectedTagValue,
                selectedLead: autoComplete,
                otherProjectDetails: otherProjectDetails,
                selectedDepartment: selectedDepartment,
                selectedTeam: selectedTeam,
                selectedUser: selectedUser,
                uploadedFiles: files,
                userDetails: userDetails,
                selectedCategoryData: selectedCategoryData._id
            };

            const response = await HttpService.createCHMticket(obj);
            if (response.status === 201) {
                props.setSnackInfo('Ticket Created Successfully', 'success');
                resetFormFields();
                setTimeout(() => {
                    const shouldRedirect = userDetails?.roles?.find(role => 
                        role.name === ROLENAME.Admin || 
                        role.name === ROLENAME.CHM_Manager || 
                        role.name === ROLENAME.CHM_User || 
                        role.name === ROLENAME.TeleCallerUser ||  
                        role.name === ROLENAME.TeleCallerManager
                    );
                    
                    if (shouldRedirect) {
                        history.push('/CHMuserDashboard');
                    } else {
                        history.push('/AssignedCHMticket');
                    }
                }, 1000);
            }
        } catch (error) {
            console.error('Error creating ticket:', error);
            props.setSnackInfo('Failed to create ticket: ' + error.message, 'error');
        }
    };

    // Handle regular form submission
    const handleSubmitButton = async (e) => {
        if (!validateForm()) {
            props.setSnackInfo('Please fill all required fields', 'warning');
            return;
        }
        
        try {
            let obj = {
                ticketTitle: ticketTitle,
                ticketDescription: ticketDescription,
                ticketETAdate: ticketETAdate,
                ticketFollowUpDate: ticketFollowUpDate,
                selectedTagValue: selectedTagValue,
                selectedLead: autoComplete,
                otherProjectDetails: otherProjectDetails,
                uploadedFiles: files,
                userDetails: userDetails,
                selectedCategoryData: selectedCategoryData._id
            };

            // Determine department assignment
            const DSEArray = ['Design', 'Sales', 'Service', 'Procurement', 'Factory', 'Operations'];
            const requiredDepartmentIdArray = allDepartments
                .filter((dp) => DSEArray.includes(dp.name))
                .map((el) => el._id);

            if (completeLeadData && 
                requiredDepartmentIdArray.includes(completeLeadData.departmentId) && 
                completeLeadData.assignTo && 
                completeLeadData.currentStage !== 'Completed') {
                
                obj.selectedDepartment = { _id: completeLeadData.departmentId };
                obj.selectedTeam = { _id: completeLeadData.teamId };
                obj.selectedUser = { _id: completeLeadData.assignTo };
            } else {
                const chmDepartment = allDepartments.find((dp) => dp.name === 'CHM');
                if (chmDepartment) {
                    obj.selectedDepartment = { _id: chmDepartment._id };
                    
                    const chmTeams = chmDepartment.teams || [];
                    if (chmTeams.length > 0) {
                        const randomTeamIndex = Math.floor(Math.random() * chmTeams.length);
                        const selectedTeamId = chmTeams[randomTeamIndex]._id;
                        obj.selectedTeam = { _id: selectedTeamId };
                        
                        const teamUsers = chmDepartment.users?.filter((user) => 
                            user.teamId === selectedTeamId
                        ) || [];
                        
                        if (teamUsers.length > 0) {
                            const randomUserIndex = Math.floor(Math.random() * teamUsers.length);
                            obj.selectedUser = { _id: teamUsers[randomUserIndex]._id };
                        }
                    }
                }
            }

            const response = await HttpService.createCHMticket(obj);

            if (response.status === 201) {
                props.setSnackInfo('Ticket Created Successfully', 'success');
                resetFormFields();
                localStorage.removeItem('CHMTicketLeadDetails');
                setTimeout(() => {
                    const shouldRedirect = userDetails?.roles?.find(role => 
                        role.name === ROLENAME.Admin || 
                        role.name === ROLENAME.CHM_Manager || 
                        role.name === ROLENAME.CHM_User || 
                        role.name === ROLENAME.TeleCallerUser ||  
                        role.name === ROLENAME.TeleCallerManager
                    );
                    
                    if (shouldRedirect) {
                        history.push('/CHMuserDashboard');
                    } else {
                        history.push('/AssignedCHMticket');
                    }
                }, 1000);
            }
        } catch (error) {
            console.error('Error creating ticket:', error);
            props.setSnackInfo('Failed to create ticket: ' + error.message, 'error');
        }
    };

    // Other handlers
    const handleTickeTitleInputChange = (e) => {
        setTicketTitle(e.target.value);
    };

    const handleOtherTypeOfTicket = (event) => {
        const { name, value } = event.target;
        setOtherProjectDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const handleTickeDescriptionInputChange = (e) => {
        setTicketDescription(e.target.value);
    };

    const handleETAdateInputChange = (e) => {
        const selectedDate = new Date(e.target.value);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        if (selectedDate >= currentDate) {
            setTicketETAdate(e.target.value);
        } else {
            props.setSnackInfo("Please select a date in the present or future.", 'warning');
        }
    };

    const handleticketFollowUpDateInputChange = (e) => {
        const selectedDate = new Date(e.target.value);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        if (selectedDate >= currentDate) {
            setTicketFollowUpDate(e.target.value);
        } else {
            props.setSnackInfo("Please select a date in the present or future.", 'warning');
        }
    };

    const handleTeamSelectionAutocomplete = (v) => {
        if (v != null) {
            setSelectedTeam(v);
            const teamUsers = selectedDepartment?.users?.filter((user) => 
                (user.teamId && user?.teamId) === v?._id
            ) || [];
            setUsersOfSelectedTeam(teamUsers);
        }
    };

    const onImageChangeCheck = async (e, index) => {
        const newFiles = [...files];
        
        if (e.target.files && e.target.files[0]) {
            props.setLoading(true);
            const fd = new FormData();
            fd.append("file", e.target.files[0]);
            
            try {
                const fileUploadRes = await HttpService.uploadFile(fd);
                newFiles[index] = fileUploadRes.data;
                setFiles(newFiles);
            } catch (err) {
                props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
            }
            props.setLoading(false);
        }
    };

    const handleAddFileInput = () => {
        let newFiles = [...files];
        newFiles.push("");
        setFiles(newFiles);
    };

    const handleRemoveFileInput = (index) => {
        const newFiles = files.filter((file,id) => id !== index);
        setFiles([...newFiles]);
    };

    const categoryDataApi = async () => {
        props.setLoading(true);
        try {
            const { data } = await HttpService.getAllCHMticketCategory();
            const excluded = new Set([
                "Referral Bonus", "Refund", "Balance Statement", "Installation Query",
                "Invoice Query", "Design Query", "Production Query", "False Ceiling",
                "Snag", "Partial Material Delivery", "DKO Rejection", "Sales query",
                "Carpenter Issue", "Other query", "Career", "Vendor", "Marketing_Old"
            ]);
            setCategoryData(data.filter(item => item?.value && !excluded.has(item.value)));
        } catch (error) {
            console.error('Error loading categories:', error);
        } finally {
            props.setLoading(false);
        }
    };

    const getDatadepartments = async () => {
        props.setLoading(true);
        try {
            const departments = await HttpService.getDepartments();
            setAllDepartments(departments.data.filter((data) => data !== null && data !== undefined));
        } catch (error) {
            console.error('Error loading departments:', error);
        } finally {
            props.setLoading(false);
        }
    };

    // Get autocomplete label based on selected type
    const getAutocompleteLabel = () => {
        switch(selectedTagValue) {
            case 'lead_no':
                return "Search Lead No...";
            case 'erpProjectNo':
                return "Search Project No...";
            case 'uniqueLeadNumber':
                return "Search Unique Lead No...";
            default:
                return "Search...";
        }
    };

    return (
      <div>
        {userDetails?.roles?.find(
          (role) =>
            role.name === ROLENAME.CHM_Manager ||
            role.name === ROLENAME.CHM_User ||
            role.name === ROLENAME.TeleCallerUser ||
            role.name === ROLENAME.TeleCallerManager || 
            role.name === ROLENAME.Admin
        ) && (
          <Paper>
            <Grid
              container
              className={classes.tablecontainer}
              direction="column"
              justifyContent="space-evenly"
              alignItems="flex-start"
              key="parentGridContainer"
            >
              <TextField
                id="ticketTitle"
                key="ticketTitle"
                name="Ticket Title"
                label="Ticket Title"
                value={ticketTitle}
                defaultValue="Ticket Title"
                onChange={handleTickeTitleInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                className={classes.textField}
                required
              />

              <TextField
                id="ticketDescription"
                key="ticketDescription"
                name="Ticket Description"
                label="Ticket Description"
                value={ticketDescription}
                defaultValue="Ticket Description"
                onChange={handleTickeDescriptionInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                className={classes.textField}
                required
              />

                        {/* Category Selection */}
                        {categoryData && (
                            <Autocomplete
                                value={selectedCategoryData}
                                key="selectedCategoryData"
                                onChange={(e, newValue) => setSelectedCategoryData(newValue)}
                                options={categoryData}
                                getOptionLabel={(option) => option?.value || ''}
                                className={classes.autocompleteContainer}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tag Category"
                                        fullWidth
                                        variant="outlined"
                                        required
                                    />
                                )}
                            />
                        )}

                        {/* Resolution Expected Date */}
                        <TextField
                            id="ticketETAdate"
                            key="ticketETAdate"
                            name="ticketETAdate"
                            label="Resolution Expected Date"
                            type="date"
                            value={ticketETAdate}
                            onChange={handleETAdateInputChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.dateField}
                            required
                        />

                        {/* Follow Up Date */}
                        <TextField
                            id="ticketFollowUpDate"
                            key="ticketFollowUpDate"
                            name="ticketFollowUpDate"
                            label="Follow Up Date"
                            type="date"
                            value={ticketFollowUpDate}
                            onChange={handleticketFollowUpDateInputChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.dateField}
                            required
                        />

                        {/* File Upload Section */}
                        {files?.map((file, index) => (
                            <div
                                key={index}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    margin: 10,
                                    padding: 2,
                                }}
                            >
                                <FormControl style={{ width: 500 }}>
                                    <input
                                        key={`${index}`}
                                        accept="*"
                                        className={classes.input}
                                        id={`contained-button-file-${index}`}
                                        name="chmImageAttachment"
                                        onChange={(e) => onImageChangeCheck(e, index)}
                                        type="file"
                                        style={{ display: "none" }}
                                    />
                                    <label htmlFor={`contained-button-file-${index}`}>
                                        <Button
                                            variant="contained"
                                            style={{ background: "#1C375D", color: "#FFF2EB" }}
                                            component="span"
                                        >
                                            Upload Customer Issue Attachments
                                        </Button>
                                    </label>
                                </FormControl>
                                {files[index] !== "" && (
                                    <CheckCircleIcon
                                        style={{
                                            verticalAlign: "middle",
                                            color: "green",
                                            fontSize: 30,
                                            marginLeft: 10,
                                        }}
                                    />
                                )}
                                <Button
                                    onClick={handleAddFileInput}
                                    startIcon={<AddCircleOutlineRoundedIcon />}
                                    style={{ marginLeft: 10 }}
                                />
                                {index !== 0 && (
                                    <Button
                                        onClick={() => handleRemoveFileInput(index)}
                                        startIcon={<DeleteOutlineOutlinedIcon />}
                                        style={{ marginLeft: 10 }}
                                    />
                                )}
                            </div>
                        ))}

                        {/* Project Selection Radio Group */}
                        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                            <FormControl className={classes.FormControl}>
                                <FormLabel id="demo-radio-buttons-group-label">
                                    Select Project number
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    value={selectedTagValue}
                                    onChange={handleLeadTagChange}
                                    name="radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value="lead_no"
                                        control={<Radio />}
                                        label="Lead No"
                                    />
                                    <FormControlLabel
                                        value="erpProjectNo"
                                        control={<Radio />}
                                        label="Project No"
                                    />
                                    <FormControlLabel
                                        value="uniqueLeadNumber"
                                        control={<Radio />}
                                        label="Unique Lead No"
                                    />
                                    <FormControlLabel
                                        value="other"
                                        control={<Radio />}
                                        label="Other"
                                    />
                                </RadioGroup>

                                {/* Other Project Details */}
                                {selectedTagValue === 'other' && (
                                    <div className={classes.textFieldContainer}>
                                        <TextField
                                            id="otherLeadName"
                                            name="name"
                                            label="Enter Name"
                                            variant="outlined"
                                            value={otherProjectDetails.name}
                                            onChange={handleOtherTypeOfTicket}
                                            className={classes.textField}
                                            required
                                        />
                                        <TextField
                                            id="otherLeadPhone"
                                            name="mobile"
                                            label="Enter Phone"
                                            variant="outlined"
                                            value={otherProjectDetails.mobile}
                                            onChange={handleOtherTypeOfTicket}
                                            inputProps={{
                                                minLength: 10,
                                                maxLength: 10,
                                                pattern: "[0-9]*"
                                            }}
                                            className={classes.textField}
                                            required
                                        />
                                        <TextField
                                            id="otherEmail"
                                            name="email"
                                            label="Enter Email"
                                            variant="outlined"
                                            value={otherProjectDetails.email}
                                            onChange={handleOtherTypeOfTicket}
                                            className={classes.textField}
                                            required
                                        />
                                    </div>
                                )}
                            </FormControl>

                            {/* Autocomplete Search Field (for non-other options) */}
                            {selectedTagValue !== 'other' && (
                                <Autocomplete
                                    value={autoComplete}
                                    onChange={handleLeadSelectionAutoComplete}
                                    onInputChange={handleSearchInputChange}
                                    inputValue={searchInput}
                                    options={getCurrentData()}
                                    getOptionLabel={getOptionLabel}
                                    className={classes.autocompleteContainer}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={getAutocompleteLabel()}
                                            fullWidth
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {isSearching ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                    loading={isSearching}
                                    loadingText="Searching..."
                                    noOptionsText={
                                        !searchInput || searchInput.length < 2
                                            ? "Type at least 2 characters to search"
                                            : "No results found"
                                    }
                                    filterOptions={(x) => x}
                                />
                            )}
                        </Grid>

                        {/* Department/Team/User Selection (for Other option) */}
                        {selectedTagValue === 'other' && (
                            <>
                                <Autocomplete
                                    value={selectedDepartment}
                                    onChange={(e, newValue) => setSelectedDepartment(newValue || {})}
                                    options={allDepartments}
                                    getOptionLabel={(option) => option?.name || ''}
                                    className={classes.autocompleteContainer}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Tag Department"
                                            fullWidth
                                            variant="outlined"
                                            required
                                        />
                                    )}
                                />

                                {selectedDepartment?.teams && (
                                    <Autocomplete
                                        value={selectedTeam}
                                        onChange={(e, newValue) => handleTeamSelectionAutocomplete(newValue)}
                                        options={selectedDepartment?.teams || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        className={classes.autocompleteContainer}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Tag Team"
                                                fullWidth
                                                variant="outlined"
                                                required
                                            />
                                        )}
                                    />
                                )}

                                {selectedDepartment?.users && (
                                    <Autocomplete
                                        value={selectedUser}
                                        onChange={(e, newValue) => setSelectedUser(newValue || {})}
                                        options={usersOfSelectedTeam}
                                        getOptionLabel={(option) => option?.name || ''}
                                        className={classes.autocompleteContainer}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Tag User"
                                                fullWidth
                                                variant="outlined"
                                                required
                                            />
                                        )}
                                    />
                                )}
                            </>
                        )}

                        {/* Submit Buttons */}
                        {selectedTagValue === 'other' ? (
                            <Button
                                color="primary"
                                variant="contained"
                                style={{
                                    padding: 10,
                                    width: 180,
                                    textAlign: "center",
                                    margin: 20,
                                    height: 30,
                                }}
                                onClick={handleOtherTicket}
                                disabled={!validateForm()}
                            >
                                Create New Ticket
                            </Button>
                        ) : (
                            <Button
                                color="primary"
                                variant="contained"
                                style={{
                                    padding: 10,
                                    width: 180,
                                    textAlign: "center",
                                    margin: 20,
                                    height: 30,
                                }}
                                onClick={handleSubmitButton}
                                disabled={!validateForm()}
                            >
                                Create New Ticket
                            </Button>
                        )}
                    </Grid>
                </Paper>
            )}
        </div>
    );
};

export default connect(null, { setUserDetails, setLoading, setSnackInfo })(ChmTicketForm);